var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineChartIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 8.375C8.05312 8.375 8.72125 9.31063 9.42875 10.3006C10.2488 11.4487 11.1788 12.75 12.75 12.75C16.2938 12.75 17.6125 6.00625 17.75 5.25L16.52 5.02625C16.2188 6.67625 14.8713 11.5 12.75 11.5C11.8219 11.5 11.1537 10.5644 10.4462 9.57438C9.62625 8.42625 8.69625 7.125 7.125 7.125C4.50875 7.125 2.47187 11.7525 1.5 14.4762V0.25H0.25V16.5C0.250496 16.8314 0.382351 17.149 0.616664 17.3833C0.850977 17.6176 1.16863 17.7495 1.5 17.75H17.75V16.5H2.1525C3.09625 13.2856 5.2275 8.375 7.125 8.375Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineChartIcon);
export default __webpack_public_path__ + "static/media/LineChartIcon.b1daa4b18af7f838614a95f8be30c458.svg";
export { ForwardRef as ReactComponent };